[data-toggle=collapse] .more-alerts-button{display:none}[data-toggle=collapse].collapsed .more-alerts-button{display:inline}[data-toggle=collapse].collapsed .fewer-alerts-button{display:none}
/*# sourceMappingURL=alerting.component-7WS7MJ6A.css.map */
